import React from 'react';
import { Card, Table } from 'antd';
import { ToolOutlined } from '@ant-design/icons';

interface ProductionStage {
  key: string;
  stage: string;
  count: number;
}

interface ProductionStateWidgetProps {
  productionStages: ProductionStage[];
}

const ProductionStateWidget: React.FC<ProductionStateWidgetProps> = ({
  productionStages,
}) => {
  const columns = [
    {
      title: 'Production Stage',
      dataIndex: 'stage',
      key: 'stage',
      render: (text: string) => (
        <span>
          <ToolOutlined style={{ marginRight: 8 }} />
          {text}
        </span>
      ),
    },
    {
      title: 'Items Count',
      dataIndex: 'count',
      key: 'count',
      align: 'right' as const,
    },
  ];

  return (
    <Card 
      title="Production State by Stages" 
      bordered={false} 
      className="dashboard-card"
      style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      <Table 
        dataSource={productionStages}
        columns={columns}
        pagination={false}
        size="middle"
        style={{ fontSize: '16px' }}
        className="vertical-aligned-table"
        showHeader={true}
      />
    </Card>
  );
};

export default ProductionStateWidget;
